//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { PAGE_HEADER_SELECTOR } from 'app/constants/global-elements';

(function() {
    // Scrolls the document to a target anchor, taking in mind the current size of the sticky header.
  angular.module('curalate').factory('$dynamicAnchorScroll', [
    '$anchorScroll',
    '$location',
    function(
            $anchorScroll,
            $location,
        ) {
      return function(hash) {
        $anchorScroll.yOffset = $(PAGE_HEADER_SELECTOR)[0].clientHeight;
        return $anchorScroll(hash || $location.hash);
      };
    },
  ]);
})();
